// src/utils/userValidation.js
export const validateName = (value) => {
  const nameRegex = /^[A-Za-zא-ת\s-]+$/;
  if (!nameRegex.test(value)) {
    return 'Name must contain only letters, spaces, and hyphens (A-Z, a-z, א-ת, -, space).';
  }
  return null;
};

export const validatePassword = (value) => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  if (value && !passwordRegex.test(value)) {
    return 'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, and one number.';
  }
  return null;
};

export const validateEmail = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (value && !emailRegex.test(value)) {
    return 'Please enter a valid email address (e.g., example@domain.com).';
  }
  return null;
};

// export const validateUsername = (value) => {
//   if (value.length < 3) {
//     return 'Username must be at least 3 characters long.';
//   }
//   return null;
// };
